module.exports = __webpack_public_path__ + "media/images/loupe-f7681d223d60e37bf0c9e594f208ddb4.svg";